export const Types = {
  START_FIND_VENDOR_BANK_DETAIL: 'START_FIND_VENDOR_BANK_DETAIL',
  END_FIND_VENDOR_BANK_DETAIL: 'END_FIND_VENDOR_BANK_DETAIL',
};
